export default __webpack_public_path__ + "static/media/Remove-Plant.3a91d5cb.svg";